<div class="container">
  <app-simple-autocomplete-value-accessor label="Wybierz zlecającego"
                                          [data]="lessors"
                                          [formControl]="lessorForm">
  </app-simple-autocomplete-value-accessor>
</div>
